import React, { ComponentProps } from 'react'

type TProps = { isActive?: boolean } & ComponentProps<'svg'>

const Export: React.FC<TProps> = ({ isActive = false, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      aria-label="내보내기"
      {...props}
    >
      <desc>내보내기</desc>
      <path fill="none" d="M0 0h20v20H0z" data-name="사각형 10787"></path>
      <g data-name="그룹 10107">
        <path
          fill="none"
          stroke={isActive ? '#01a0ff' : '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M3 11.255v5.746h14v-5.746"
          data-name="패스 8077"
        ></path>
        <g data-name="그룹 10105" transform="rotate(180 6.415 6.268)">
          <path
            fill="none"
            stroke={isActive ? '#01a0ff' : '#333333'}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5.657 5.709L2.828 8.537 0 5.71"
            data-name="패스 8078"
          ></path>
          <rect
            width="2"
            height="8"
            fill={isActive ? '#01a0ff' : '#333333'}
            data-name="사각형 10886"
            rx="1"
            transform="translate(1.76)"
          ></rect>
        </g>
      </g>
    </svg>
  )
}

export default Export
